import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Input, Select, notification, Image } from 'antd';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';
import { useEffectOnce } from "react-use";
import {
    addToFavorites,
    fetchChatByPartner,
    getComplaints,
    postComplaints,
    postUserMessage,
    removeFromFavorites,
} from "../../../api";
import { setProductDetails } from "../../../redux/actions/product_actions";
import { useProductDetailsQuery } from "../../../hooks/product";
import DetailsImageCarousel from "./contents/details_image_carousel";
import BorderedTile from "./contents/bordered_tile";
import CommentsBlock from "./contents/comments_bloc";
import { useUserStore } from "../../../store/user_store";
import Conditional from "../../components/conditional";
import UserTile from "./contents/user_tile";
import QuickMessages from "./contents/quick_message";
import ShareButtons from "./contents/share_buttons";

const key = "updateable";
const { TextArea } = Input;

var DG = require('2gis-maps');

const openNotificationWithIcon = (type, info) => {
    notification[type]({
        message: info,
    });
};

// Premium SVG Icons
const PhoneIcon = () => (
    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
);

const StarIcon = ({ filled = false }) => (
    <svg className={`w-5 h-5 mr-2 ${filled ? "text-amber-500" : "text-slate-500"}`} fill={filled ? "currentColor" : "none"} stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.907c.969 0 1.371 1.24.588 1.81l-3.97 2.883a1 1 0 00-.364 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.971-2.883a1 1 0 00-1.178 0l-3.97 2.883c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.364-1.118L2.98 12.08c-.783-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
    </svg>
);

const AlertIcon = () => (
    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
    </svg>
);

const EyeIcon = () => (
    <svg className="w-4 h-4 text-slate-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
);

const ClockIcon = () => (
    <svg className="w-4 h-4 text-slate-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const MapPinIcon = () => (
    <svg className="w-4 h-4 text-slate-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
);

const ProductDetailPage = ({ match }) => {
    const dispatch = useDispatch();
    const { user, isAuthenticated } = useUserStore();
    const isAuth = isAuthenticated;

    const params = useParams();
    const query = useProductDetailsQuery(params.id);
    const productDetails = query.product;

    const [favorite, setFavorite] = useState();
    const [complaintsText, setComplaintsText] = useState();
    const [reason, setReason] = useState();
    const [childrens, setChildrens] = useState();
    const [loadings, setLoadings] = useState();
    const [messag, setMessage] = useState();
    const [chatId, setChatId] = useState();
    const [location, setLocation] = useState(undefined);
    const [map1, setMap1] = useState(<div id="map" className="w-full h-[350px] rounded-2xl border border-slate-100 overflow-hidden mt-3 shadow-sm"></div>);

    useEffect(() => {
        if (productDetails != null) {
            dispatch(setProductDetails(productDetails));
            setFavorite(productDetails.is_favorite);

            var position = productDetails.location;
            if (position != undefined) {
                let parsedLocation = null;
                try {
                    if (typeof position === 'string') {
                        const trimmed = position.trim();
                        if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
                            parsedLocation = JSON.parse(position);
                        }
                    } else if (typeof position === 'object') {
                        parsedLocation = position;
                    }
                } catch (e) {
                    console.warn('Failed to parse location coordinates', e);
                }

                if (parsedLocation && parsedLocation.latitude && parsedLocation.longitude) {
                    setLocation(parsedLocation);

                    var map;
                    DG.then(function () {
                        map = DG.map('map', {
                            'center': [parsedLocation.latitude, parsedLocation.longitude],
                            'zoom': 13
                        });
                        DG.marker([parsedLocation.latitude, parsedLocation.longitude]).addTo(map);
                    });
                } else {
                    setLocation(null);
                }
            }

            document.title = productDetails.title;
        }
    }, [productDetails]);

    useEffectOnce(() => {
        moment.locale('ru');
    });

    const fetchComplaints = async () => {
        const complaints = await getComplaints();
        if (complaints != null) {
            setChildrens(complaints);
        }
    }

    const addFav = async () => {
        await addToFavorites(productDetails.id);
        notification.success({ message: 'Добавлено в избранное!', duration: 2 });
        setFavorite(true);
    }

    const removeFav = async () => {
        await removeFromFavorites(productDetails.id);
        notification.info({ message: 'Удалено из избранного!', duration: 2 });
        setFavorite(false);
    }

    useEffectOnce(() => {
        fetchComplaints();
    });

    const PostComplaint = async () => {
        const params = {
            'complaint_type_id': reason,
            'text': complaintsText,
            'advertisement_id': productDetails.id
        }
        await postComplaints(params);
        notification.success({ message: "Ваше обращение отправлено!" });
    }

    const [visible, setVisible] = React.useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);

    const showModal = () => {
        setVisible(true);
    };

    function handleChange(value) {
        setReason(value);
    }

    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setVisible(false);
            setConfirmLoading(false);
        }, 2000);
    };

    const handleCancel = () => {
        setVisible(false);
    };

    if (query.isLoading) {
        return (
            <div className="flex flex-col w-full min-h-[500px] items-center justify-center">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-blue-600 border-r-2 border-slate-100"></div>
            </div>
        )
    }

    if (productDetails == null) {
        return (
            <div className="flex flex-col w-full min-h-[500px] items-center justify-center text-slate-500 font-semibold">
                Объявление не найдено
            </div>
        )
    }

    const postQuickMessage = async (message) => {
        if (message) {
            if (!chatId) {
                const chat = await fetchChatByPartner(productDetails.user_id);
                if (chat) {
                    setChatId(chat.id);
                }
            }

            await postUserMessage({ 'user_id': productDetails.user_id, 'message': message, 'advertisement_id': productDetails.id });
            setMessage("");
            openNotificationWithIcon('success', 'Сообщение отправлено!');
        } else {
            openNotificationWithIcon('error', 'Заполните поле для сообщения!');
        }
    }

    var time = moment(productDetails.created_at, 'YYYYMMDD, H:mm:ss');
    var update = time.fromNow();
    const phones = productDetails.phones;

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
            {/* Back Button */}
            <div>
                <Link
                    to="/"
                    className="group inline-flex items-center text-sm font-semibold text-blue-600 hover:text-blue-700 no-underline transition"
                >
                    <svg className="w-4 h-4 mr-1.5 text-blue-600 group-hover:-translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    Назад к объявлениям
                </Link>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
                {/* Main Product Info (Left Column) */}
                <div className="lg:col-span-8 space-y-6">
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden p-6 md:p-8 space-y-6">
                        {/* Title */}
                        <h1 className="text-2xl md:text-3xl font-bold text-slate-800 tracking-tight leading-tight">
                            {productDetails.title}
                        </h1>

                        {/* Carousel / Image container */}
                        <div className="w-full rounded-2xl overflow-hidden bg-slate-50 border border-slate-100 relative">
                            {productDetails.media.length > 0 ? (
                                <DetailsImageCarousel
                                    images={productDetails.media.map((item) => item.original_url)}
                                    className="h-[350px] md:h-[500px] w-full object-cover transition-all duration-300"
                                />
                            ) : (
                                <div className="h-[350px] md:h-[500px] flex items-center justify-center text-slate-400 font-medium">
                                    Нет изображения
                                </div>
                            )}
                        </div>

                        {/* Details Tiles */}
                        <div className="space-y-4">
                            <h2 className="text-lg font-bold text-slate-800 tracking-tight pb-2 border-b border-slate-100">
                                Характеристики и описание
                            </h2>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <BorderedTile title="Категория">
                                    <div className="flex flex-wrap items-center text-sm">
                                        {productDetails.category_tree?.map((item, index) => (
                                            <span key={index} className="flex items-center text-slate-600 font-medium">
                                                <Link to={"/category/" + item.id} className="text-blue-600 hover:underline">
                                                    {item.name}
                                                </Link>
                                                <span className="mx-1 text-slate-300">/</span>
                                            </span>
                                        ))}
                                        <Link to={"/category/" + productDetails.category.id} className="text-blue-600 font-semibold hover:underline">
                                            {productDetails.category.name}
                                        </Link>
                                    </div>
                                </BorderedTile>

                                <BorderedTile title="Цена">
                                    <span className="text-blue-600 font-bold text-lg">{productDetails.priceWithCurrency}</span>
                                </BorderedTile>

                                <BorderedTile title="Город">
                                    <span className="text-slate-700 font-semibold">{productDetails.city.name}</span>
                                </BorderedTile>

                                {productDetails.district && (
                                    <BorderedTile title="Район">
                                        <span className="text-slate-700 font-semibold">{productDetails.district.name}</span>
                                    </BorderedTile>
                                )}

                                {productDetails.custom_attributes?.map((item, index) => (
                                    <BorderedTile key={index} title={item.attribute.name}>
                                        <span className="text-slate-700 font-semibold">{item.value}</span>
                                    </BorderedTile>
                                ))}
                            </div>

                            {/* Description - FIXED FROM LOREM IPSUM */}
                            <BorderedTile title="Описание объявления">
                                <p className="text-slate-600 text-sm leading-relaxed whitespace-pre-wrap font-medium">
                                    {productDetails.description || "Описание не указано."}
                                </p>
                            </BorderedTile>
                        </div>
                    </div>
                    {/* Comments Section */}
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 md:p-8">
                        <h3 className="text-xl font-bold text-slate-800 tracking-tight mb-4">Комментарии</h3>
                        <CommentsBlock product={productDetails} />
                    </div>
                </div>

                {/* Sidebar (Right Column) */}
                <div className="lg:col-span-4 space-y-6">
                    {/* Action Cards */}
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 space-y-4">
                        {/* Price Display */}
                        <div className="bg-slate-50 p-4 rounded-xl text-center border border-slate-100">
                            <span className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">Стоимость</span>
                            <span className="text-2xl font-extrabold text-blue-600">{productDetails.priceWithCurrency}</span>
                        </div>

                        {/* Call Button */}
                        <button
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-xl flex items-center justify-center shadow-sm shadow-blue-100 hover:shadow-md transition"
                            data-toggle="collapse"
                            href="#multiCollapseExample1"
                            role="button"
                            aria-expanded="false"
                            aria-controls="multiCollapseExample1"
                        >
                            <PhoneIcon />
                            <span>Показать номер телефона</span>
                        </button>

                        <div className="collapse multi-collapse" id="multiCollapseExample1">
                            <div className="bg-slate-50 border border-slate-100 p-4 rounded-xl text-center font-bold text-slate-800 text-lg space-y-2 mt-2">
                                {phones && phones.length > 12 ? (
                                    <div className="flex flex-col gap-2">
                                        {phones.split(",").map((item, index) => (
                                            <a href={"tel:" + item} key={index} className="text-blue-600 hover:underline">{item.trim()}</a>
                                        ))}
                                    </div>
                                ) : (
                                    <a href={"tel:" + phones} className="text-blue-600 hover:underline">{phones}</a>
                                )}
                            </div>
                        </div>

                        {/* Favorites Button */}
                        <Conditional condition={isAuth}>
                            {favorite ? (
                                <button
                                    className="w-full bg-amber-50 hover:bg-amber-100 text-amber-700 font-semibold py-3 px-4 rounded-xl flex items-center justify-center border border-amber-200 transition"
                                    onClick={removeFav}
                                >
                                    <StarIcon filled={true} />
                                    <span>Удалить из избранного</span>
                                </button>
                            ) : (
                                <button
                                    className="w-full bg-white hover:bg-slate-50 text-slate-700 font-semibold py-3 px-4 rounded-xl flex items-center justify-center border border-slate-200 transition"
                                    onClick={addFav}
                                >
                                    <StarIcon filled={false} />
                                    <span>Добавить в избранное</span>
                                </button>
                            )}
                        </Conditional>

                        {/* Report Button */}
                        <button
                            className="w-full bg-rose-50 hover:bg-rose-100 text-rose-700 font-semibold py-3 px-4 rounded-xl flex items-center justify-center border border-rose-200 transition"
                            onClick={showModal}
                        >
                            <AlertIcon />
                            <span>Пожаловаться</span>
                        </button>

                        <hr className="border-slate-100 my-4" />

                        {/* User Profile Info Card */}
                        <div className="bg-slate-50/50 border border-slate-100 p-4 rounded-xl">
                            <UserTile user={productDetails.user} />
                        </div>

                        <ShareButtons />

                        {/* Views Metrics */}
                        <div className="pt-3 border-t border-slate-100 flex flex-col gap-2.5 text-slate-500 text-xs font-semibold">
                            <div className="flex items-center">
                                <EyeIcon />
                                <span>Просмотры: <strong className="text-slate-700 ml-1">{productDetails.views}</strong></span>
                            </div>
                            <div className="flex items-center">
                                <ClockIcon />
                                <span>Обновлено: <strong className="text-slate-700 ml-1">{update}</strong></span>
                            </div>
                            <div className="flex items-center">
                                <StarIcon filled={false} />
                                <span>В избранном у: <strong className="text-slate-700 ml-1">{productDetails.fav_count} пользователей</strong></span>
                            </div>
                            <div className="flex items-center">
                                <MapPinIcon />
                                <span>Регион: <strong className="text-slate-700 ml-1">{productDetails.region != null ? `${productDetails.region.name}, ${productDetails.city.name}` : productDetails.city.name}</strong></span>
                            </div>
                        </div>
                    </div>

                    {/* Quick Message Input Card */}
                    {isAuth && (
                        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-4">
                            <div className="w-full text-center rounded-xl p-3 border-2 border-dashed border-slate-200 bg-slate-50 text-slate-600 text-xs font-bold">
                                Написать сообщение {productDetails.user.name}
                            </div>
                            <QuickMessages messageSendHandler={(message) => postQuickMessage(message)} />
                        </div>
                    )}

                    {/* Map location Card */}
                    {location != null && (
                        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5">
                            <h3 className="text-sm font-bold text-slate-800 mb-3 flex items-center">
                                <MapPinIcon />
                                Местоположение на карте
                            </h3>
                            {map1}
                        </div>
                    )}
                </div>
            </div>


            {/* Complaint Modal Dialog */}
            <Modal
                title={<span className="font-bold text-slate-800 text-base">Пожаловаться на объявление</span>}
                visible={visible}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
                footer={null}
                width={500}
                bodyStyle={{ padding: '20px' }}
            >
                <div className="space-y-4">
                    <div className="space-y-1.5">
                        <label className="text-sm font-semibold text-slate-700">Причина жалобы:</label>
                        <Select size="large" onChange={handleChange} className="w-full rounded-xl">
                            {childrens?.length ? childrens.map((item, index) => (
                                <Select.Option key={index} value={item.id}>{item.name}</Select.Option>
                            )) : null}
                        </Select>
                    </div>
                    <div className="space-y-1.5">
                        <label className="text-sm font-semibold text-slate-700">Комментарий:</label>
                        <TextArea className="rounded-xl" rows={4} placeholder="Пожалуйста, уточните детали жалобы..." onChange={(e) => setComplaintsText(e.target.value)} />
                    </div>
                    <div className="flex justify-end gap-3 pt-3 border-t border-slate-50">
                        <button className="px-4 py-2 text-sm font-semibold rounded-xl border border-slate-200 text-slate-600 hover:bg-slate-50 transition" onClick={handleCancel}>Закрыть</button>
                        <button className="px-4 py-2 text-sm font-semibold rounded-xl bg-rose-600 text-white hover:bg-rose-700 transition" onClick={PostComplaint}>Отправить жалобу</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default ProductDetailPage;